import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiListDataService } from './api.list-data.service';
import { ProjectItemOrganizationModel } from '../../models';

@Injectable({
    providedIn: 'root',
})
export class ApiProjectItemOrganizationService extends ApiListDataService<
    ProjectItemOrganizationModel,
    ProjectItemOrganizationModel
> {
    constructor(http: HttpClient) {
        super(http, '/ProjectItemOrganization/');
    }
}
